import ApiCallService from '../Service/ApiCallService';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function getPushStatus() {
  const supported = 'serviceWorker' in navigator && 'PushManager' in window;
  if (!supported) {
    return { supported: false, permission: 'unsupported', isSubscribed: false };
  }

  const permission = Notification.permission;
  let isSubscribed = false;

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      const subscription = await registration.pushManager.getSubscription();
      isSubscribed = !!subscription;
    }
  } catch (err) {
    console.error('[Push] Error checking push subscription status:', err);
  }

  return { supported: true, permission, isSubscribed };
}

export async function subscribeUserToPush(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('[Push] Web Push notifications are not supported in this browser.');
    return { success: false, reason: 'not_supported' };
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('[Push] Notification permission was denied/dismissed:', permission);
      return { success: false, reason: permission };
    }

    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    const keyRes = await ApiCallService.get('/push/vapid-public-key');
    const publicKey = keyRes?.publicKey;

    if (!publicKey) {
      console.error('[Push] Server returned empty VAPID public key.');
      return { success: false, reason: 'no_vapid_key' };
    }

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    const targetUserId =
      userId ||
      localStorage.getItem('userId') ||
      localStorage.getItem('loggedInUserID');

    if (targetUserId) {
      await ApiCallService.post('/push/subscribe', {
        userId: targetUserId,
        subscription,
      });
      console.log('✅ [Push] Subscription successfully registered for user:', targetUserId);
      return { success: true, subscription };
    } else {
      console.warn('[Push] No user ID available to save push subscription.');
      return { success: false, reason: 'no_user_id' };
    }
  } catch (error) {
    console.error('[Push] Failed to subscribe user to push notifications:', error);
    return { success: false, reason: error.message || 'error' };
  }
}

export async function unsubscribeUserFromPush(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { success: false, reason: 'not_supported' };
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const targetUserId =
        userId ||
        localStorage.getItem('userId') ||
        localStorage.getItem('loggedInUserID');

      if (targetUserId) {
        await ApiCallService.delete('/push/unsubscribe', {
          data: {
            userId: targetUserId,
            endpoint: subscription.endpoint,
          },
        });
      }

      await subscription.unsubscribe();
      console.log('✅ [Push] Push notification subscription removed.');
      return { success: true };
    }
  } catch (error) {
    console.error('[Push] Failed to unsubscribe from push notifications:', error);
    return { success: false, reason: error.message || 'error' };
  }

  return { success: true };
}
